<div
    class="{{ size }} color-{{ color }} badge"
    [ngClass]="{
        inversed: isInversed
    }"
>
    <ng-content></ng-content>
    <span>{{ text }}</span>
</div>
